import { CourseData } from '@containers/activity-router/data-grid-container/courses/types/courses.types';
import { ActivitiesTopics } from '@containers/activity-router/routes/learn/activities/activities.types';

export enum TopicFilterCheckboxesVariants {
    topicFilterCheckbox = 'topicFilterCheckbox'
}

export type TopicFilterProps = {
    selectedCourse: CourseData
    selectedFiltersTopics: ActivitiesTopics
    setFiltersTopic: (topics: ActivitiesTopics) => void
    clearFilterCallback: () => void
};
